import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noLabel: {
		id: 'issue-table-grouping.group-row.group-header.label-group-header.no-label',
		defaultMessage: 'No labels',
		description: 'Label for grouped items without label',
	},
});
export default messages;
